import { useContext } from 'react';
import { GlobalSpinnerContext } from '@/components/GlobalSpinnerProvider';

export function useGlobalSpinner() {
  const context = useContext(GlobalSpinnerContext);
  if (!context) {
    throw new Error('useGlobalSpinner must be used within a GlobalSpinnerProvider');
  }
  return context;
}
